/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Inline_MessageInputs */

const de_commons_error_inline_message = /** @type {(inputs: Commons_Error_Inline_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese Daten konnten nicht geladen werden. Bitte versuchen Sie es erneut.`)
};

/** @type {(inputs: Commons_Error_Inline_MessageInputs) => LocalizedString} */
const en_commons_error_inline_message = de_commons_error_inline_message;

/**

* @param {Commons_Error_Inline_MessageInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_inline_message = /** @type {((inputs?: Commons_Error_Inline_MessageInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Inline_MessageInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_inline_message(inputs)
	return en_commons_error_inline_message(inputs)
});